/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import {
    CashBoxAlertsHistoryDto,
    CashBoxAlertsHistoryExcelParams,
    CashBoxAlertsHistoryQueryParams,
} from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';

export enum CashBoxAlertsTabActionType {
    EXIT_CASHBOX_ALERTS_TAB = 'CashBoxAlertsTab/ exit tab',
    FETCH_CASHBOX_ALERTS_HISTORY = 'CashBoxAlertsTab/ fetch alerts history start',
    FETCH_CASHBOX_ALERTS_HISTORY_SUCCESS = 'CashBoxAlertsTab/ fetch alerts history success',
    FETCH_CASHBOX_ALERTS_HISTORY_ERROR = 'CashBoxAlertsTab/ fetch alerts history error',
    DOWNLOAD_ALERTS_HISTORY = 'CashBoxAlertsTab/ download alerts history as excel start',
    DOWNLOAD_ALERTS_HISTORY_SUCCESS = 'CashBoxAlertsTab/ download alerts history as excel success',
    DOWNLOAD_ALERTS_HISTORY_ERROR = 'CashBoxAlertsTab/ download alerts history as excel error',
}

export const exitCashBoxAlertsTabAction = () => createAction(CashBoxAlertsTabActionType.EXIT_CASHBOX_ALERTS_TAB);

export const fetchCashBoxAlertsHistoryAction = (params: CashBoxAlertsHistoryQueryParams) =>
    createAction(CashBoxAlertsTabActionType.FETCH_CASHBOX_ALERTS_HISTORY, params);

export const fetchCashBoxAlertsHistorySuccessAction = (payload: CashBoxAlertsHistoryDto) =>
    createAction(CashBoxAlertsTabActionType.FETCH_CASHBOX_ALERTS_HISTORY_SUCCESS, payload);

export const fetchCashBoxAlertsHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxAlertsTabActionType.FETCH_CASHBOX_ALERTS_HISTORY_ERROR, { notification });

export const downloadAlertsHistoryAction = (params: CashBoxAlertsHistoryExcelParams) =>
    createAction(CashBoxAlertsTabActionType.DOWNLOAD_ALERTS_HISTORY, params);

export const downloadAlertsHistorySuccessAction = () =>
    createAction(CashBoxAlertsTabActionType.DOWNLOAD_ALERTS_HISTORY_SUCCESS);

export const downloadAlertsHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxAlertsTabActionType.DOWNLOAD_ALERTS_HISTORY_ERROR, { notification });

export type CashBoxAlertsTabAction =
    | ReturnType<typeof exitCashBoxAlertsTabAction>
    | ReturnType<typeof fetchCashBoxAlertsHistoryAction>
    | ReturnType<typeof fetchCashBoxAlertsHistorySuccessAction>
    | ReturnType<typeof fetchCashBoxAlertsHistoryErrorAction>
    | ReturnType<typeof downloadAlertsHistoryAction>
    | ReturnType<typeof downloadAlertsHistorySuccessAction>
    | ReturnType<typeof downloadAlertsHistoryErrorAction>;
